import axios from 'axios';
import CONSTS from '../../config/constants';
import Env from '../../config/environment';
import FileSaver from 'file-saver';

const { API_APP } = CONSTS.SERVICES;
const env = Env();
const version = env.app.version;

export const downloadDocExcel = (props) => axios.get(`/b/docs/${version}/documents/list/excel?estado=${props.activeState}`, {
  headers: {
    service: API_APP,
  },
})
  .then(response => {
    var arrayBuffer = Buffer.from(response.data.payload, 'base64');
    const blob = new Blob([arrayBuffer], { type: 'xlsx;charset=utf-8' });
    FileSaver.saveAs(blob, `contract-${props.activeState !== '' ? props.activeState : 'all'}.xlsx`);
  });